<div class="main-container-component d-flex flex-column">
  <div class="position-relative d-md-flex flex-row-reverse align-items-center">
    <h1 class="main-container-header text-start text-md-center ms-5 mx-md-auto my-3" *ngIf="header">
      {{ header }}
    </h1>
    <div class="hipervinculo" *ngIf="backButton">
      <app-hyperlink-icon icon="arrow-left" (clicked)="onClick()">Volver</app-hyperlink-icon>
    </div>
  </div>
  <p class="main-container-subheader text-start text-md-center ms-5 mx-md-auto" *ngIf="subheader">
    {{ subheader }}
  </p>
  <div class="main-container-body d-flex align-items-start flex-column flex-grow-1 mx-auto">
    <div class="main-container-body-card mx-auto">
      <div class="main-container-body-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
